import api from '../../helpers/axios'

export const state = {
    smsLog: null,
    smsLogs: []
};

export const getters = {
    smsLog: (state) => state.smsLog,
    smsLogs: (state) => state.smsLogs
};

export const mutations = {
    setSmsLog(state, newValue) {
        state.smsLog = newValue;
    },
    setSmsLogs(state, newValue) {
        state.smsLogs = newValue;
    },
};

export const actions = {
    createSmsLog(_,  data) {
        return new Promise((resolve) => {
            api.post("/sms-templates", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    updateSmsLog(_, {id,data}) {
        return new Promise((resolve) => {
            api.put("/sms-templates/"+id, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deleteSmsLog(_, id) {
        return new Promise((resolve) => {
            api.delete("/sms-templates/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchSmsLog({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/sms-templates/"+id).then((res) => {
                commit("setSmsLog", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchSmsLogs({ commit }, params) {
        return new Promise((resolve) => {
            api.get("/sms-templates", {params: {...params}}).then((res) => {
                commit("setSmsLogs", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
